export enum LOCAL_STORAGE_KEYS {
  CREATOR_PROFILE = "creator-profile",
  STEP_IN_PROGRESS = "step-in-progress",
  IS_MOBILE_SCREEN = "isMobileScreen",
  IS_FRESH_SESSION = "isFreshSession",
  USER_LOCATION = "userLocation",
  IS_ASKED_FOR_PREMIUM = "isAskedForPremium",
  IS_ASKED_TO_COMPLETE_PREMIUM_PROFILE = "isAskedToCompletePremiumProfile",
}
